/* Cart print estimate — builds an isolated print window from the current cart.
   Extracted from sections/main-cart-desktop.liquid because apps (e.g. Essential
   Countdown Timer) were injecting their own <script>/<style> tags INSIDE our
   inline script's string literals, whose premature </script> terminated our
   cart script tag and caused raw JS to render as visible text on the page.
   Living here (as a static .js asset) means Shopify can't post-process content
   into the middle of our strings. */
(function(){
  document.addEventListener('click', function(e){
    var trigger = e.target.closest('[data-cd-print-estimate]');
    if (!trigger) return;
    var root = document.querySelector('[data-cd-cart-root], body');

    var rows = Array.prototype.slice.call(document.querySelectorAll('.cd-item'));
    var lines = rows.map(function(it){
      var t = it.querySelector('.cd-item-title');
      var p = it.querySelector('[data-cd-line-price]') || it.querySelector('.cd-item-price');
      var q = it.querySelector('[data-cd-qty-input]');
      var brand = it.querySelector('.cd-item-brand');
      var variant = it.querySelector('.cd-item-variant');
      return {
        title: t ? (t.textContent || '').trim() : '',
        brand: brand ? (brand.textContent || '').trim() : '',
        variant: variant ? (variant.textContent || '').trim() : '',
        price: p ? (p.textContent || '').trim() : '',
        qty: q ? (q.value || '1') : '1'
      };
    }).filter(function(l){ return l.title; });

    var totalEl = document.querySelector('[data-cd-summary-total]') || document.querySelector('[data-cd-sticky-total]');
    var total = totalEl ? totalEl.textContent.trim() : '';
    var now = new Date();
    var stamp = now.toLocaleDateString('en-CA',{year:'numeric',month:'short',day:'numeric'}) +
                ' \u00b7 ' + now.toLocaleTimeString('en-CA',{hour:'2-digit',minute:'2-digit'});
    var esc = function(s){ return String(s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); };

    var rowsHtml = lines.map(function(l){
      var sub = [l.brand, l.variant].filter(Boolean).join(' \u00b7 ');
      return '<tr>' +
        '<td class="t"><div class="nm">' + esc(l.title) + '</div>' + (sub ? '<div class="sb">' + esc(sub) + '</div>' : '') + '</td>' +
        '<td class="q">' + esc(l.qty) + '</td>' +
        '<td class="p">' + esc(l.price) + '</td>' +
        '</tr>';
    }).join('');

    var css = [
      '*{box-sizing:border-box}body{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif;color:#1a1a1a;padding:36px 44px;margin:0;font-size:13px;line-height:1.45}',
      '.hd{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:2px solid #2d5a3d;padding-bottom:14px;margin-bottom:22px}',
      '.hd h1{margin:0 0 4px;font-size:22px;letter-spacing:-0.3px;color:#2d5a3d}',
      '.hd .sub{font-size:11.5px;color:#666}',
      '.hd .co{text-align:right;font-size:11.5px;color:#444;line-height:1.5}',
      '.hd .co b{color:#1a1a1a}',
      'h2{font-size:14px;margin:0 0 10px;letter-spacing:0.3px;text-transform:uppercase;color:#666;font-weight:700}',
      'table{width:100%;border-collapse:collapse;margin-bottom:18px}',
      'thead th{text-align:left;font-size:10.5px;letter-spacing:0.6px;text-transform:uppercase;color:#888;font-weight:700;padding:8px 10px;border-bottom:1px solid #ccc}',
      'thead th.q{text-align:center;width:70px}thead th.p{text-align:right;width:110px}',
      'tbody td{padding:12px 10px;border-bottom:1px solid #eee;vertical-align:top}',
      'tbody td.q{text-align:center}tbody td.p{text-align:right;font-weight:700}',
      '.nm{font-weight:700;font-size:13px;margin-bottom:2px}',
      '.sb{font-size:11px;color:#666}',
      'tfoot td{padding:14px 10px;font-size:14px;font-weight:800;border-top:2px solid #1a1a1a}',
      'tfoot td.p{text-align:right;font-size:18px;color:#C8820A}',
      '.ftn{margin-top:28px;padding-top:14px;border-top:1px solid #eee;font-size:11px;color:#666;line-height:1.6}',
      '.ftn b{color:#1a1a1a}',
      '@media print{body{padding:24px}}'
    ].join('');

    var html = '<!doctype html><html><head><meta charset="utf-8"><title>Cart Estimate \u2014 Home Care Supply</title>' +
      '<sty'+'le>' + css + '</st'+'yle></head><body>' +
      '<div class="hd">' +
        '<div><h1>Cart Estimate</h1><div class="sub">Home Care Supply \u00b7 Printed ' + esc(stamp) + '</div></div>' +
        '<div class="co"><b>Home Care Supply</b><br>(647) 233-5442<br>homecaresupply.ca</div>' +
      '</div>' +
      '<h2>Items</h2>' +
      '<table><thead><tr><th class="t">Product</th><th class="q">Qty</th><th class="p">Price</th></tr></thead>' +
      '<tbody>' + (rowsHtml || '<tr><td colspan="3" style="padding:20px;color:#999;text-align:center">No items in cart.</td></tr>') + '</tbody>' +
      (total ? '<tfoot><tr><td colspan="2">Estimated Total</td><td class="p">' + esc(total) + '</td></tr></tfoot>' : '') +
      '</table>' +
      '<div class="ftn"><b>This is an estimate only.</b> Final pricing including HST and delivery is confirmed at checkout. Prices and availability may change. Save this document or share it with your partner / contractor for approval. Questions? Call <b>(647) 233-5442</b>.</div>' +
      '</body></html>';

    var w = window.open('', '_blank', 'width=820,height=1040');
    if (!w) { alert('Please allow pop-ups to print your cart estimate.'); return; }
    w.document.open();
    w.document.write(html);
    w.document.close();
    w.focus();
    setTimeout(function(){ try { w.print(); } catch(err){} }, 450);
  });
})();
